// Transparent header (home, and product page on mobile): header and logo start hidden (class set in Liquid) and `.header_wrap--scrolled` brings the background and logo back, triggered by the element flagged `data-header-transparent-until` scrolling under the header, or else by the hero logo reaching ~20px from the top, or else by the first banner scrolling under the header.
(function () {
  var header = document.querySelector(".header_wrap");
  if (!header) return;
  if (!header.classList.contains("header_wrap--transparent") && !header.classList.contains("header_wrap--transparent-mobile")) {
    return;
  }

  var heroLogo = document.querySelector(".section_banner--hero [data-banner-logo]") || document.querySelector("[data-banner-logo]");
  var heroSection = document.querySelector(".section_banner");

  // Distance from the top of the viewport at which the hero logo is considered to have reached the header.
  var LOGO_THRESHOLD = 20;

  function headerHeight() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue("--header-height");
    var n = parseInt(raw, 10);
    return isNaN(n) ? 60 : n;
  }

  function apply(scrolled) {
    header.classList.toggle("header_wrap--scrolled", scrolled);
  }

  /** The hero logo is transformed by GSAP on every frame (banner-logo.js), so reading its rect from a scroll handler forced a style recalc plus a full layout each frame; IntersectionObserver reports the same transformed geometry from the browser's own post-layout step, at no cost to the frame. */
  function watchLogo() {
    if (!heroLogo || !("IntersectionObserver" in window)) return false;

    // The logo crosses the threshold line *inside* the observed region, where a plain 0/1 threshold never fires: stepped ratios give a callback every ~1% of the logo height instead.
    var thresholds = [];
    for (var i = 0; i <= 100; i++) thresholds.push(i / 100);

    new IntersectionObserver(
      function (entries) {
        // Entries come in chronological order; only the latest geometry matters.
        apply(entries[entries.length - 1].boundingClientRect.top <= LOGO_THRESHOLD);
      },
      { rootMargin: "-" + LOGO_THRESHOLD + "px 0px 0px 0px", threshold: thresholds }
    ).observe(heroLogo);

    return true;
  }

  if (watchLogo()) return;

  // Fallbacks: nothing here is animated, so the scroll listener reads a clean layout.
  function isScrolled() {
    if (heroLogo) {
      return heroLogo.getBoundingClientRect().top <= LOGO_THRESHOLD;
    }
    if (heroSection) {
      return heroSection.getBoundingClientRect().bottom <= headerHeight();
    }
    return (window.scrollY || window.pageYOffset || 0) > 0;
  }

  var ticking = false;
  function update() {
    ticking = false;
    apply(isScrolled());
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true },
  );
  window.addEventListener("resize", update);
  update();
})();
